import { render, staticRenderFns } from "./zhengce.vue?vue&type=template&id=f68d8334&scoped=true&"
import script from "./zhengce.vue?vue&type=script&lang=js&"
export * from "./zhengce.vue?vue&type=script&lang=js&"
import style0 from "./zhengce.vue?vue&type=style&index=0&id=f68d8334&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68d8334",
  null
  
)

export default component.exports